module.exports = __webpack_public_path__ + "static/media/technical-university-dublin.cc517ed3.png";